/**
 * Get whether a value is not undefined.
 *
 * @param value - The value to check.
 * @public
 */ export function isDefined(value) {
    return value !== undefined;
}
/**
 * Get whether a value is null
 *
 * @param value - The value to check.
 * @public
 */ export function isNonNull(value) {
    return value !== null;
}
/**
 * Get whether a value is nullish (null, undefined).
 *
 * @param value - The value to check.
 * @public
 */ export function isNonNullish(value) {
    return value !== null && value !== undefined;
}
/** @public */ export const structuredClone = typeof window !== 'undefined' && window.structuredClone ? window.structuredClone : (i)=>i ? JSON.parse(JSON.stringify(i)) : i;
